import { TranslationEntity } from "../../components"

export class SupplierOfferModel {

  completionDeadline?: Date;

  createdBy?: number;

  createdOn?: Date;

  id: number;

  isDeleted?: boolean;

  requestRoundSupplierId?: number;

  requestSubject?: string;

  supplierOfferStatusId?: number;

  updatedBy?: number;

  updatedOn?: Date;



  // custom-start
  translationName: TranslationEntity;

  // custom-end

  constructor() {
  }
}

export enum SupplierOfferStatus {
  InProgress = "InProgress",
  Entered = "Entered",
  Submitted = "Submitted"
}

export class ReadMessageModel {
  messageId: number;
  tableName: string;
}

export class ReadMessagesModel {
  supplierOfferId: number;
  items: ReadMessageModel[] = [];
}

export class LastReadMessageModel {
  readTime: Date;
}
